var exports = {
  "qd": "FloatingUnreadIndicators.module__layer___bldzYl",
  "NI": "FloatingUnreadIndicators.module__slot___bldzYl",
  "AH": "FloatingUnreadIndicators.module__slotTop___bldzYl",
  "Y0": "FloatingUnreadIndicators.module__slotBottom___bldzYl",
  "q3": "FloatingUnreadIndicators.module__indicator___bldzYl",
  "lL": "FloatingUnreadIndicators.module__indicatorBrand___bldzYl",
  "Gi": "FloatingUnreadIndicators.module__indicatorMention___bldzYl",
};

module.exports = exports;
